
import { Button } from '@/components/ui/button';
import { ArrowRight, Star } from 'lucide-react';

const HeroContent = () => {
  const scrollToServices = () => {
    const servicesSection = document.querySelector('.services-scroll-target');
    if (servicesSection) {
      const headerHeight = 80; // Account for fixed header
      const offset = servicesSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ 
        top: offset, 
        behavior: 'smooth' 
      });
    }
  };

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
          <div className="inline-flex items-center px-4 py-2 bg-green-50 rounded-full text-nexx-green text-sm font-medium">
            🎯 2,000+ Satisfied Users
          </div>
          <a 
            href="https://www.google.com/search?q=nexx+telecom+trustpilot&sca_esv=a95b1a567a7f3cbf&sxsrf=AE3TifNL-fnEMBqPOwm9R8z5qPpUYZHw6Q%3A1759856608527&ei=4EflaNbyH-iIwbkP9OKOqAM&ved=0ahUKEwjW4obgyJKQAxVoRDABHXSxAzUQ4dUDCBA&uact=5&oq=nexx+telecom+trustpilot&gs_lp=Egxnd3Mtd2l6LXNlcnAiF25leHggdGVsZWNvbSB0cnVzdHBpbG90MgUQABjvBTIIEAAYgAQYogQyCBAAGIAEGKIEMggQABiABBiiBDIIEAAYgAQYogRI_hNQ7AFY0RJwAXgAkAEAmAHyAaAB-g6qAQYwLjEwLjK4AQPIAQD4AQGYAgygAqANwgINECMYgAQYsAMYJxiKBcICBxAjGLADGCfCAggQABiABBiwA8ICBxAAGLADGB7CAg4QABiABBiwAxiGAxiKBcICCBAAGLADGO8FwgILEAAYgAQYsAMYogTCAgoQIxiABBgnGIoFwgIEECMYJ8ICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIHECEYoAEYCsICBRAhGKABmAMAiAYBkAYKkgcFMS45LjKgB-IrsgcFMC45LjK4B5sNwgcFNi41LjHIBw4&sclient=gws-wiz-serp" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 bg-green-50 rounded-full text-nexx-green text-sm font-medium border border-green-200 hover:bg-green-100 transition-colors cursor-pointer"
          >
            <Star className="w-4 h-4 fill-green-500 text-green-500 mr-1" />
            <span className="font-semibold text-green-700">4.1</span>
            <span className="ml-1 text-green-600">Verified Reviews</span>
          </a>
        </div>
        
        {/* This should be the LCP element */}
        <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
          Customized Data Center
          <span className="text-nexx-green"> Solutions</span>
        </h1>
        
        <p className="text-xl text-gray-600 leading-relaxed">
          Purpose-built infrastructure for scale, speed, and control. From{' '}
          <span 
            className="text-nexx-green"
            style={{
              filter: 'drop-shadow(0 0 4px rgba(34, 197, 94, 0.3)) drop-shadow(0 0 8px rgba(34, 197, 94, 0.15))',
              textShadow: '0 0 4px rgba(34, 197, 94, 0.2)'
            }}
          >
            residential proxies
          </span>{' '}
          to{' '}
          <span className="underline decoration-nexx-green decoration-2 underline-offset-2">
            bare metal servers
          </span>
          ,{' '}
          we deliver{' '}
          <span 
            className="text-nexx-green inline-block"
            style={{
              filter: 'drop-shadow(0 0 8px rgba(34, 197, 94, 0.7))',
              animation: 'glitch 2s infinite linear alternate-reverse'
            }}
          >
            custom connectivity
          </span>{' '}
          solutions built for{' '}
          <span className="font-bold text-gray-900">serious operators</span>.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <Button 
          size="lg" 
          className="bg-nexx-green hover:bg-green-700 text-white px-8 py-4 text-lg group"
          data-tally-open="3NQKvW" 
          data-tally-emoji-text="👋" 
          data-tally-emoji-animation="wave"
        >
          Get Trial
          <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
        </Button>
        <Button 
          size="lg" 
          variant="outline" 
          className="border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white px-8 py-4 text-lg"
          onClick={scrollToServices}
        >
          Order Now
        </Button>
      </div>
    </div>
  );
};

export default HeroContent;
